<template>
    <project-step-container
            cover-page
            prev-to="be_deep_customer_empathy_9"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <div class="content-cover">
            <div class="content-cover-item first-form-initial-2">
                <div class="content-cover-item-header">
                    <div class="broad-icon"/>
                </div>
                <div class="content-cover-item-body">
                    <p class="content-cover-item-body-title text-uppercase " tabindex="0">{{getMessage(10, 'gobroadtogonarrow-title')}}</p>
                    <p class="content-cover-item-body-description" tabindex="0">
                      {{getMessage(10, 'gobroadtogonarrow-sub')}}
                    </p>
                </div>
                <div class="content-cover-item-footer points-icon"></div>
            </div>
            <div class="content-cover-item content-guide ">
                <LinkStyleGuide class="guide-text" @open-url="openGuide" :is-box-shadow="false"
                                icon-name="icon-guide" :text="getMessage(10, 'gobroadtogonarrow-guide')" />
            </div>
        </div>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide";
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {Steps} from "@/modules/BeEntrepreneurship/Utils";

    export default {
        name: "GoBroadToGoNarrow10",
        components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step:Steps.FORM_BROAD_NARROW,
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.GO_BROAD_TO_GO_NARROW)
            }
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'be_go_broad_to_go_narrow_11', params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
   
    .subtitle
        font font-sourcesans-bold
        font-size 20px
    .broad-icon
        background url("../../D4D/Images/icon-broad-narrow.svg")
        height 89px
        width 183px
        background-repeat no-repeat

    .points-icon
        background url("../../D4D/Images/points.svg")
        width 100%
        height 55px
        border-radius 0 0 27px 27px
</style>
